const emojis = [
  { title: 'smiley face', character: '😊' },
  { title: 'grinning face', character: '😀' },
  { title: 'laughing face', character: '😆' },
  { title: 'winking face', character: '😉' },
  { title: 'heart eyes', character: '😍' },
  { title: 'thinking face', character: '🤔' },
  { title: 'crying face', character: '😢' },
  { title: 'angry face', character: '😡' },
  { title: 'party face', character: '🥳' },
  { title: 'sleeping face', character: '😴' },
  { title: 'shocked face', character: '😱' },
  { title: 'rolling eyes', character: '🙄' },

  // Hand Gestures
  { title: 'thumbs up', character: '👍' },
  { title: 'thumbs down', character: '👎' },
  { title: 'clapping hands', character: '👏' },
  { title: 'raising hands', character: '🙌' },
  { title: 'peace sign', character: '✌️' },
  { title: 'OK hand', character: '👌' },
  { title: 'fist bump', character: '👊' },
  { title: 'crossed fingers', character: '🤞' },

  // Nature
  { title: 'sun', character: '☀️' },
  { title: 'moon', character: '🌙' },
  { title: 'star', character: '⭐' },
  { title: 'rainbow', character: '🌈' },
  { title: 'fire', character: '🔥' },
  { title: 'tree', character: '🌳' },
  { title: 'flower', character: '🌸' },
  { title: 'snowflake', character: '❄️' },
  { title: 'wind blowing face', character: '🌬️' },
  { title: 'ocean wave', character: '🌊' },

  // Objects
  { title: 'floppy disk', character: '💾' },
  { title: 'laptop', character: '💻' },
  { title: 'mobile phone', character: '📱' },
  { title: 'camera', character: '📷' },
  { title: 'light bulb', character: '💡' },
  { title: 'wrench', character: '🔧' },
  { title: 'clock', character: '⏰' },
  { title: 'hourglass', character: '⏳' },
  { title: 'shopping cart', character: '🛒' },

  // Symbols
  { title: 'heart', character: '❤️' },
  { title: 'broken heart', character: '💔' },
  { title: 'check mark', character: '✔️' },
  { title: 'cross mark', character: '❌' },
  { title: 'warning sign', character: '⚠️' },
  { title: 'infinity', character: '♾️' },
  { title: 'question mark', character: '❓' },

  // Transport
  { title: 'rocket', character: '🚀' },
  { title: 'airplane', character: '✈️' },
  { title: 'car', character: '🚗' },
  { title: 'bus', character: '🚌' },
  { title: 'train', character: '🚆' },
  { title: 'ship', character: '🚢' },
  { title: 'bicycle', character: '🚲' },
  { title: 'motorcycle', character: '🏍️' },

  // Food & Drink
  { title: 'pizza', character: '🍕' },
  { title: 'burger', character: '🍔' },
  { title: 'ice cream', character: '🍦' },
  { title: 'coffee', character: '☕' },
  { title: 'beer', character: '🍺' },
  { title: 'birthday cake', character: '🎂' },
  { title: 'chocolate', character: '🍫' },
  { title: 'apple', character: '🍎' },

  // Sports & Activities
  { title: 'soccer ball', character: '⚽' },
  { title: 'basketball', character: '🏀' },
  { title: 'football', character: '🏈' },
  { title: 'tennis', character: '🎾' },
  { title: 'trophy', character: '🏆' },
  { title: 'musical note', character: '🎵' },
  { title: 'guitar', character: '🎸' },
  { title: 'video game', character: '🎮' },

  // Travel & Places
  { title: 'globe', character: '🌍' },
  { title: 'mountain', character: '⛰️' },
  { title: 'beach', character: '🏖️' },
  { title: 'house', character: '🏠' },
  { title: 'office building', character: '🏢' },
  { title: 'hospital', character: '🏥' },
  { title: 'church', character: '⛪' },
];

export default emojis;
